import React from 'react';
import { Typography, Tabs } from 'antd';

const { Title } = Typography;

const OwnDeviceTab = React.lazy(() => import('./tabs/OwnDeviceTab'));
const AutoProfitTab = React.lazy(() => import('./tabs/AutoProfitTab'));

const AppProfit = () => {
  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>App分润</Title></div>
      <Tabs defaultActiveKey="manual" items={[
        { key: 'manual', label: 'App分润配置', children: <React.Suspense fallback="加载中..."><OwnDeviceTab /></React.Suspense> },
        { key: 'auto', label: '自动分润配置', children: <React.Suspense fallback="加载中..."><AutoProfitTab /></React.Suspense> },
      ]} />
    </div>
  );
};

export default AppProfit;
